import { z } from 'my-zod'
import { customerOrderBookingPlatformOptions } from '../../customer-operations/customer-order'
import { CustomerOrderFinanceSchemas } from './customer-order-finance-types'
import { TypeTesting } from '../../internal/type-testing'

export const customerInvoiceSchema = z.object({
  platform: z.enum(['Polaris']),
  total: z.number().int().nullable(),
  amountPaid: z.number().int().nullable(),
  undisputedAmountPaid: z.number().int().nullable(),
  amountAuthorized: z.number().int(),
  amountRemaining: z.number().int(),
  tax: z.number().int().nullable(),
  totalExcludingTax: z.number().int().nullable(),
  disputedAmount: z.number().int().nullable(),
  disputedAmountRecoveredByOutfitter: z.number().int().nullable(),
  requestedRefundAmount: z.number().int(),
  lines: z
    .object({
      id: z.string(),
      displayName: z.string(),
      type: z.enum([
        'Reservation',
        'Merchandise',
        'RentalEquipment',
        'CancellationFee',
        'DamageFee',
        'AdHoc',
        'WeatherGuarantee',
        'RideInsurance',
        'GiftCard'
      ]),
      platform: z.enum(customerOrderBookingPlatformOptions),
      amount: z.number().int().nullable()
    })
    .array(),
  discounts: z
    .object({
      amount: z.number().int(),
      discount: z.object({
        id: z.string(),
        providedBy: z.enum(['Polaris', 'Outfitter']),
        amount: z.number().int(),
        displayName: z.string(),
        unit: z.enum(['fixedAmountOffTotal', 'percentOffEach', 'percentOffSingle']),
        type: z.enum(['Promotion', 'AdHoc']),
        promotionShortId: z.string().nullable(),
        promotionVersionId: z.number().nullable()
      })
    })
    .array(),
  taxes: z
    .object({
      amount: z.number().int(),
      policy: z.object({
        id: z.number(),
        unit: z.enum(['flat', 'percentage']),
        amount: z.number(),
        title: z.string()
      })
    })
    .array(),
  payments: z
    .object({
      amount: z.number().int().nullable(),
      amountRefunded: z.number().int().nullable(),
      method: z.enum(['cash', 'check', 'card', 'external', 'giftCard']),
      refunds: z
        .object({
          amount: z.number().int().nullable()
        })
        .array()
    })
    .array(),
  authorizations: z
    .object({
      chargeId: z.string(),
      paymentMethodId: z.string(),
      amount: z.number().int()
    })
    .array()
}) satisfies z.ZodSchema<CustomerOrderFinanceSchemas.CustomerInvoice>

// this is a type test - do not delete
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type InvoiceTypeIsCorrectTest = TypeTesting.Expect<
  TypeTesting.IsEqual<z.infer<typeof customerInvoiceSchema>, CustomerOrderFinanceSchemas.CustomerInvoice>
>
